import type { ITemplateNode } from '@ifs-gcp/core';
import { isTabCardNode, isTabNode } from '@ifs-gcp/core/helpers';
import type { PageChild } from '@ifs-gcp/core/models';

import { getTabCardProps } from '../utils';

interface NavigationStep {
  mainTabId: string;
  cardId?: string;
  cardTabValue?: string;
}

export const buildNavigationSequence = (
  auditTemplate: ITemplateNode<PageChild>,
): NavigationStep[] => {
  const { cardBody } = getTabCardProps(auditTemplate.children);

  return cardBody.flatMap((panel) => {
    const mainTabId = panel.props.value;

    if (!mainTabId) {
      return [];
    }

    /**
     * If no tab card is found, then we are in main tab
     * If in future we add a tab card that is not a module tab, this needs to be adjusted
     */
    const tabCardNode = panel.children.find(isTabCardNode);

    if (!tabCardNode?.props.id) {
      return [{ mainTabId }];
    }

    const { cardTitle: subTabs } = getTabCardProps(tabCardNode.children);

    const subTabIds = subTabs.children.filter(isTabNode).map((child) => child.props.value);

    if (!subTabIds.length) {
      return [{ mainTabId }];
    }

    return subTabIds.map((cardTabValue) => ({
      mainTabId,
      cardId: tabCardNode.props.id,
      cardTabValue,
    }));
  });
};
